import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { DocentesEncontrados } from './DocentesEncontrados'
import ModificarRegistros from './ModificarRegistros'
import AgregarMateria from './AgregarMateria'
import { useNavigate } from 'react-router-dom'
import ModDocente from './ModDocente'

const baseUrl = 'https://datosprofes.cpem46.edu.ar/Backendphp/obtener_docente.php'
const urlEliminar = 'https://datosprofes.cpem46.edu.ar/Backendphp/eliminar_materia.php'
const urlEliminarDocente = 'https://datosprofes.cpem46.edu.ar/Backendphp/eliminar_docente.php'

const DatosPersonales = () => {  
  const [materias, setMaterias] = useState([])
  const [dniBusqueda, setDniBusqueda] = useState('')
  const [nombreBusqueda, setNombreBusqueda] = useState('')
  const [docentesEncontrados, setDocentesEncontrados] = useState([])
  const [docenteSeleccionado, setDocenteSeleccionado] = useState(null)

  const [variablebuscar, setVariableBuscar] = useState('buscar')
  const [seccion, setSeccion] = useState('')
  const [materiaSeleccionada, setMateriaSeleccionada] = useState(null)
  const [docentesMA, setDocenteMA] = useState ('')

  const usuario = JSON.parse(localStorage.getItem("user"))

  const [modDocente, setModDocente] = useState('')


  const handleBuscar = () => {
    setVariableBuscar('Nueva Busqueda')
    setMaterias([])
    setDocenteSeleccionado(null)
    setDocentesEncontrados([])

    let url = baseUrl

    if (dniBusqueda.trim()) {
      url += `?dni=${dniBusqueda}`
    } else if (nombreBusqueda.trim()) {
      url += `?apellido=${nombreBusqueda}`
    }
    // si no se pone nada, queda la URL base: trae todos

    axios.get(url)
      .then(res => {
        if (res.data && res.data.length > 0) {

          const docentesMap = new Map();

          res.data.forEach(doc => {
            if (!docentesMap.has(doc.dni)) {
              docentesMap.set(doc.dni, { ...doc, tieneMaterias: false });
            }
            if (doc.materia_id) {
              docentesMap.get(doc.dni).tieneMaterias = true;
            }
          });

          const docentesUnicos = Array.from(docentesMap.values());

          if (docentesUnicos.length > 1) {
            setDocentesEncontrados(docentesUnicos)
          } else {
            const dniDocente = docentesUnicos[0].dni
            const materiasDelDocente = res.data.filter(d => d.dni === dniDocente)
            procesarDocente(docentesUnicos[0], materiasDelDocente)
          }
        } else {
          Swal.fire({
            title: 'Sin resultados',
            text: 'No se encontraron docentes.',
            icon: 'info',
          })
        }
      })
      .catch(err => {
        console.error(err)
        Swal.fire({
          title: 'Error',
          text: 'No se pudieron obtener los datos.',
          icon: 'error',
        })
      })

    setNombreBusqueda('')
    setDniBusqueda('')
  }


  const procesarDocente = (docenteData, dataCompleta) => {

    setDocenteSeleccionado({
      nombre: docenteData.nombre,
      apellido: docenteData.apellido,
      dni: docenteData.dni,
      id: docenteData.id, 
      fecha_nac: docenteData.fecha_nac,
      domicilio: docenteData.domicilio,
      telefono: docenteData.telefono,
      correo: docenteData.correo,
      titulo: docenteData.titulo,
      nempleado: docenteData.nempleado,
    })
    
    setDocenteMA ({id: docenteData.id})
  
    const materiasData = dataCompleta
      .filter(item => item.materia_id !== null) 
      .map(item => ({
        id: item.materia_id,
        tgs: item.tgs,
        cod_materia: item.cod_materia,
        cod_cargo: item.cod_cargo,
        al: item.al,
        sr: item.sr,
        sec: item.sec,
        hs: item.hs,
        asignatura: item.asignatura,
        suple_a: item.suple_a
      }))
  
    setMaterias(materiasData)
    
  

  }
  

  const handleSeleccionarDocente = (docente) => {
    setMaterias([]) 
    setDocenteSeleccionado(null)
    setDocentesEncontrados([])
  
    axios.get(`${baseUrl}?dni=${docente.dni}`,{  withCredentials: true
})
      .then(res => {
        if (res.data && res.data.length > 0) {
          const docentesUnicos = Array.from(
            new Map(res.data.map(doc => [doc.dni, doc])).values()
          )
  
          if (docentesUnicos.length > 0) {
            procesarDocente(docentesUnicos[0], res.data) 
            
          } else {
            setMaterias([])
          }

        } else {
          Swal.fire({
            title: 'Sin resultados',
            text: 'No se encontraron docentes.',
            icon: 'info',
          })
        }
      })
      .catch(err => {
        console.error(err)
        Swal.fire({
          title: 'Error',
          text: 'No se encontraron datos',
          icon: 'error',
        })
      })

  }
  

  const modificarRegistro = (materia) => {

    
    const materiaConDocente = {
      ...materia,
      docente_id: docenteSeleccionado.id, // Agregar el docente_id
    }

    
    setSeccion('modificarRegistro')

    setMateriaSeleccionada(materiaConDocente)  // Guarda la materia con el docente

    
  }
 

  const onGuardarExitoso = () => {
    // Recargar la información actual del docente
    if (docenteSeleccionado) {
      axios.get(`${baseUrl}?dni=${docenteSeleccionado.dni}`,{  withCredentials: true
})
        .then(res => {
          if (res.data && res.data.length > 0) {
            procesarDocente(res.data[0], res.data)
            setSeccion('') // volver a la pantalla principal
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  const agregarMateria = () =>{
    setSeccion ('agregarMateria')
  }
  
const borrarMateria = (materiaId) => {
  Swal.fire({
    title: 'ELIMINAR',
    text: '¿Desea eliminar esta materia?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      axios.post(urlEliminar, {
        id: materiaId
      })
      .then(res => {
        Swal.fire({
          title: 'Eliminado',
          text: 'La materia fue eliminada correctamente.',
          icon: 'success'
        })

        // Opcional: recargar datos o llamar a una función que actualice la lista
        onGuardarExitoso() // si tenés esta función como en los otros casos
      })
      .catch(err => {
        console.error(err)
        Swal.fire({
          title: 'Error',
          text: 'No se pudo eliminar la materia.',
          icon: 'error'
        })
      })
    }
  })
}

  const modificarDocente = (docente) =>{

    setSeccion('ModDocente')
    setModDocente (docente)

  }

 const borrarDocente = (docenteId) => {
  Swal.fire({
    title: 'ELIMINAR DOCENTE',
    text: '¿Desea eliminar este Docente?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      axios.post(urlEliminarDocente, {
        id: docenteId
      })
      .then(res => {
        Swal.fire({
          title: 'Eliminado',
          text: 'El docente fue eliminado correctamente.',
          icon: 'success'
        })

        // Limpiar vista y estados relacionados
        setSeccion('')
        setDocenteSeleccionado(null)
        setMaterias([])
        setDocentesEncontrados([])
        setDniBusqueda('')
        setNombreBusqueda('')
      })
      .catch(err => {
        console.error(err)
        Swal.fire({
          title: 'Error',
          text: 'No se pudo eliminar al docente.',
          icon: 'error'
        })
      })
    }
  })
}


  return (
    <div>
      {seccion === '' && (
        <div>
          <div className="buscador">            
            <h2>Planilla de Datos Personales</h2>
            <h4>Buscador </h4>
            <h6><strong>(dejar en blanco para traer a todos los docentes registrados)</strong></h6>
            <input
              type="text"
              id="apellidoBusqueda"
              value={nombreBusqueda}
              onChange={(e) => setNombreBusqueda(e.target.value)}
              placeholder="Ingrese el Apellido"
            />
            <input
              type="text"
              id="dniBusqueda"
              value={dniBusqueda}
              onChange={(e) => setDniBusqueda(e.target.value)}
              placeholder="Ingrese el DNI"
            />
            <br />
            <button onClick={handleBuscar} className="btn-buscar">{variablebuscar}</button>
          </div>

          {docentesEncontrados.length > 1 && (
            <DocentesEncontrados
              docentes={docentesEncontrados}
              onSeleccionarDocente={handleSeleccionarDocente}
            />
          )}

          <div className="planilla-container">
            {docenteSeleccionado && (
              <div className="datos-personales">
                <div><strong>Nombre y Apellido:</strong> {docenteSeleccionado.nombre}, {docenteSeleccionado.apellido}</div>
                <div><strong>DNI:</strong> {docenteSeleccionado.dni}</div>
                <div><strong>Fecha Nac.:</strong> {docenteSeleccionado.fecha_nac}</div>
                <div><strong>Domicilio:</strong> {docenteSeleccionado.domicilio}</div>
                <div><strong>Teléfono:</strong> {docenteSeleccionado.telefono}</div>
                <div><strong>Email:</strong> {docenteSeleccionado.correo}</div>
                <div><strong>Título:</strong> {docenteSeleccionado.titulo}</div>
                <div><strong>N° Empleado:</strong> {docenteSeleccionado.nempleado}</div>
                
                {usuario === 'Secretaria01' && (
                  <>
                    <button className='editar' onClick={() => modificarDocente(docenteSeleccionado)}>Editar Docente</button>
                    <button className='borrar' onClick={() => borrarDocente(docenteSeleccionado.id)}>Borrar Docente</button>
                  </>
                )}
              </div>
            )}
            
            <div>
              {docenteSeleccionado && (
                <>
                  <div className="materias-header">
                    <h2>Materias Asignadas</h2>

                    {usuario === 'Secretaria01' && (
                      <button onClick={agregarMateria} className="agregar-materia-btn">+</button>
                    )}

                  </div>      
                  <div className='tabla-responsive'>
                    <table className="tabla-asignacion">
                      <thead>
                        <tr>
                        
                          <th>TGS</th><th>Cod. Materia</th><th>Cod. Cargo</th><th>AL</th>
                          <th>SR</th><th>SEC</th><th>HS</th><th>Cargo/Asignatura</th><th>Suple a</th>
                          
                          {usuario === 'Secretaria01' && (
                            <th>Acciones</th>
                          )}
                        
                        </tr>
                      </thead>
                      <tbody>
                        {materias.length > 0 ? (
                          materias.map((item, index) => (
                            <tr key={index}>
                              <td>{item.tgs}</td>
                              <td>{item.cod_materia}</td>
                              <td>{item.cod_cargo}</td>
                              <td>{item.al}</td>
                              <td>{item.sr}</td>
                              <td>{item.sec}</td>
                              <td>{item.hs}</td>
                              <td>{item.asignatura}</td>
                              <td>{item.suple_a}</td>
                                {usuario === 'Secretaria01' && (
                                  <td>
                                    <button className='editar' onClick={() => modificarRegistro(item)}>Editar</button>
                                    <button className='borrar' onClick={() => borrarMateria(item.id)}>Borrar</button>
                                  </td>
                                )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            {usuario === 'Secretaria01' ? (
                              <td colSpan="10">No hay materias registradas...</td>
                            ):(
                              <td colSpan="9">No hay materias registradas...</td>
                            )}
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {seccion === 'modificarRegistro' && (
        <div>
          {<ModificarRegistros 
              materia={materiaSeleccionada} 
              setSeccion={setSeccion} 
              onGuardarExitoso={onGuardarExitoso}
            />
            }
        </div>
      )}

      {seccion === 'agregarMateria' && (
        <div>

          {<AgregarMateria 
            docenteId={docentesMA.id}
            setSeccion={setSeccion}            
            onGuardarExitoso={onGuardarExitoso}
          />}


        </div>
      )}

      {seccion === 'ModDocente'&&(
        <div>
          {<ModDocente          
              docente={modDocente} 
              setSeccion={setSeccion} 
              onGuardarExitoso={onGuardarExitoso}
          />}

        </div>
      )}
      

    </div>
  )
}

export default DatosPersonales
